import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'

import injectRole from '../../components/HOC/injectRole'
import TeacherMiniCompany from '../../components/views/teacher/MiniCompany'
import AdminMiniCompany from '../../components/views/admin/MiniCompany'

import { TRoles, TRoutes } from '../../shared/const'
import { mayOpenAdminPage } from '../../shared/alumni'

/*
 * Junior Mini Company (Anforderung #92). Lehrkräfte unter /mini-companies,
 * die Verwaltung unter /admin-mini-companies. Alumni bleiben draußen: Die
 * Seite steht nicht in ALUMNI_PAGES, und der Server sperrt die Routen ebenso.
 */

const nurLehrkraft = Ansicht => {
	function Seite(props) {
		return props.role === TRoles.TEACHER ? <Ansicht /> : <Redirect to={TRoutes.DASHBOARD} />
	}
	Seite.propTypes = { role: PropTypes.string.isRequired }
	return injectRole(Seite)
}

const nurVerwaltung = Ansicht => {
	function Seite(props) {
		return mayOpenAdminPage(props.role, 'miniCompanies') ? <Ansicht /> : <Redirect to={TRoutes.DASHBOARD} />
	}
	Seite.propTypes = { role: PropTypes.string.isRequired }
	return injectRole(Seite)
}

/*
 * Die eigene Liste der Lehrkraft steht seit 02.11.2026 unter „Unternehmen“
 * (pages/CompaniesList). Die alte Adresse führt dorthin.
 */
export const TeacherMiniCompaniesPage = () => <Redirect to={TRoutes.COMPANIES} />
export const TeacherMiniCompanyPage = nurLehrkraft(TeacherMiniCompany)
/*
 * Die eigene Liste der Verwaltung ist seit 31.10.2026 in „Unternehmen“
 * aufgegangen (Typ „JMC“). Die alte Adresse führt dorthin, gefiltert.
 */
export const AdminMiniCompaniesPage = () => <Redirect to={`${TRoutes.ADMIN_COMPANIES}?f_companyType=JMC`} />
export const AdminMiniCompanyPage = nurVerwaltung(AdminMiniCompany)
